import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/HomePage'
import TrainingPage from './views/TrainingPage'
import QuestionPage from './views/QuestionPage'

import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: Home,
      meta: { sidebarIndex: 1 }
    },
    {
      path: '/trainings',
      redirect: '/trainings/agent ia/description'
    },
    {
      path: '/trainings/:trainingName/:mode',
      props: true,
      name: 'TrainingPage',
      component: TrainingPage,
      meta: { sidebarIndex: 2 }
    },
    {
      path: '/question',
      name: 'QuestionPage',
      component: QuestionPage,
      meta: { sidebarIndex: 3 }
    }
  ]
})

router.beforeEach((to, from, next) => {
  try {
    gsap.to(window, {
      duration: 0.3,
      scrollTo: 0,
      ease: 'sine.inOut',
      onComplete: () => {
        if (from.name === 'HomePage') setTimeout(next, 200)
      }
    })
  } catch (e) {
    console.log('scroll error')
  }
  if (from.name !== 'HomePage') next()
})

export default router
